import LoaderSection from "../Components/LoaderSection/LoaderSection"

const Authentication = () => {
    return(
        <LoaderSection />
    )
}

export default Authentication;  